<script lang="ts">
	export let errorList = [];
</script>

{#if errorList && errorList.length}
	<div class="wrap">
		<div class="red">
			{#each errorList as err (err.message)}
				<p>{err.message}</p>
			{/each}
		</div>
		<slot />
	</div>
{/if}

<style>
	.wrap {
		text-align: center;
	}
	.red {
		color: red;
	}
</style>
